var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sub-content-container',{attrs:{"title":_vm.$t('aboutMe.education.pageLabel')}},_vm._l((_vm.completeDegrees),function(degree,i){return _c('school-degree',{key:("degree-" + i),attrs:{"degree":degree}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }